const COMMISSION_TYPE = {
  COUPON: {
    color: 'orange',
    label: '쿠폰',
    value: 'COUPON',
    level: 1,
  },
  PROMOTION: {
    color: 'red',
    label: '프로모션',
    value: 'PROMOTION',
    level: 2,
  },
  BRAND: {
    color: 'magenta',
    label: '브랜드',
    value: 'BRAND',
    level: 3,
  },
  GENERAL: {
    color: 'orange',
    label: '상품',
    value: 'GENERAL',
    level: 4,
  },
  CATEGORY: {
    color: 'blue',
    label: '카테고리',
    value: 'EARNED',
    level: 5,
  },
};

export { COMMISSION_TYPE };
